import { useMutation } from "@apollo/client";
import { Checkbox, Text } from "@chakra-ui/react";
import {
  AdminEditUserMutation,
  AdminEditUserMutationVariables,
  UserFragment,
} from "gql/graphql";
import React, { memo, useCallback } from "react";
import colors from "app/colors";
import ADMIN_EDIT_USER_MUTATION from "../_networking/admin-edit-user";
import { isEmpty } from "lodash";

interface IProps {
  user: UserFragment;
}

const AdminEditUserHidePhone = ({ user }: IProps) => {
  const [adminEditUserMutationAPI] = useMutation<
    AdminEditUserMutation,
    AdminEditUserMutationVariables
  >(ADMIN_EDIT_USER_MUTATION);

  const onHideToggled = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (user) {
        adminEditUserMutationAPI({
          variables: {
            id: user.id,
            input: {
              isHidePhone: e.target.checked,
            },
          },
          optimisticResponse: {
            __typename: "Mutation",
            adminEditUser: {
              __typename: "User",
              ...user,
              isHidePhone: e.target.checked,
            },
          },
        });
      }
    },
    [adminEditUserMutationAPI, user],
  );

  if (isEmpty(user.phone)) return null;

  return (
    <Checkbox
      id="hidePhone"
      color={colors.gray50}
      defaultChecked={user.isHidePhone}
      onChange={onHideToggled}
      size="sm"
    >
      <Text fontWeight={400} fontSize={12}>
        Hide
      </Text>
    </Checkbox>
  );
};

export default memo(AdminEditUserHidePhone);
